<div class="hang-tight">

  <div class="loading" *ngIf="!isErrorLoadingScreen">
    <img src="/assets/icons/file-check.svg">
    <div class="spinner"></div>
  </div>
  <div class="loading-error" *ngIf="isErrorLoadingScreen">
    <img src="assets/icons/clock-refresh.svg">
  </div>

  <div class="title" [ngClass]="{'error': isErrorLoadingScreen && !pastDate, 'pastDate': isErrorLoadingScreen && pastDate}"
    [innerHTML]="titleLoadingScreen"></div>
  <div class="message" [innerHTML]="messageLoadingScreen"></div>

  <button class="btn" *ngIf="displayButtonLoadingScreen" (click)="navigateToRoute()">{{'results.RETURN_HOME' | transloco}}</button>
</div>
